module.exports = __webpack_public_path__ + "media/bootstrap-icons/play-fill-97bb1d62.svg";